import Collection from '../utils/Collection';
import _ from 'lodash';

import {
  FETCH_CONVERSATIONS_SENT,
  FETCH_CONVERSATIONS_SUCCEEDED,
  FETCH_CONVERSATIONS_FAILED,
  LOAD_MORE_CONVERSATIONS_SENT,
  LOAD_MORE_CONVERSATIONS_SUCCEEDED,
  LOAD_MORE_CONVERSATIONS_FAILED,
  UPDATE_ACTIVE_CONVERSATION_ID,
} from '../actions/conversation';

import {
  SEND_MESSAGE_SENT,
  SEND_MESSAGE_SUCCEEDED,
  SEND_MESSAGE_FAILED,
  RECEIVED_NEW_MESSAGE,
} from '../actions/message';

const initialState = {
  conversations: [],
  page: 1,
  conversationsCount: 0,
  activeConversationId: null,
  activeConversationMeta: {},
  loading: false,
  saving: false,
};

export default function conversationReducer(state = initialState, action) {
  const { payload, type } = action;
  let conversation, c;
  switch (type) {
    case UPDATE_ACTIVE_CONVERSATION_ID:
      return {
        ...state,
        activeConversationId: payload.conversationId,
      };
    case LOAD_MORE_CONVERSATIONS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        conversations: Collection.add(
          state.conversations,
          payload.conversations,
        ),
        conversationsCount: payload.total_count,
        page: payload.conversation_page,
      };
    case FETCH_CONVERSATIONS_SUCCEEDED:
      return {
        ...state,
        loading: false,
        conversations: Collection.reset(
          state.conversations,
          payload.conversations,
        ),
        conversationsCount: payload.total_count,
        page: payload.conversation_page,
        activeConversationMeta: payload.active_conversation_meta
          ? payload.active_conversation_meta
          : {},
      };
    case FETCH_CONVERSATIONS_SENT:
    case LOAD_MORE_CONVERSATIONS_SENT:
      return {
        ...state,
        loading: true,
      };
    case FETCH_CONVERSATIONS_FAILED:
    case LOAD_MORE_CONVERSATIONS_FAILED:
      return {
        ...state,
        loading: false,
      };
    case SEND_MESSAGE_SENT:
      conversation = payload.conversationObj.toPlainObject();
      c = Collection.get(state.conversations, conversation.id);
      // Use deep equality check instead of broken Immutable.Map comparison
      if (!_.isEqual(c, conversation)) {
        return {
          ...state,
          conversations: Collection.removeAndAdd(
            state.conversations,
            conversation,
          ),
        };
      } else {
        return state;
      }
    case SEND_MESSAGE_SUCCEEDED:
      c = Collection.get(state.conversations, payload.conversation.id);
      // Use deep equality check instead of broken Immutable.Map comparison
      if (!_.isEqual(c, payload.conversation)) {
        return {
          ...state,
          conversations: Collection.removeAndAdd(
            state.conversations,
            payload.conversation,
          ),
        };
      } else {
        return state;
      }
    case SEND_MESSAGE_FAILED:
      conversation = payload.conversationObj.toPlainObject();
      return {
        ...state,
        conversations: Collection.update(
          state.conversations,
          conversation.id,
          conversation,
        ),
      };
    case RECEIVED_NEW_MESSAGE:
      c = Collection.get(state.conversations, payload.conversation.id);
      if (c) {
        return {
          ...state,
          conversations: Collection.update(
            state.conversations,
            payload.conversation.id,
            payload.conversation,
          ),
        };
      } else {
        return {
          ...state,
          conversations: Collection.add(
            state.conversations,
            payload.conversation,
          ),
        };
      }
    default:
      return state;
  }
}
